<div class="d-flex flex-column bg-white message-container">  
  <ng-container *ngIf="isBulk; else candidateMsg">
    <div style="padding: 16px 16px 8px; border-bottom: 1px solid #BDBDBD;" >
      <div class="w-100">
        <div class="d-flex align-items-center justify-content-between" style="margin-top: -1px;">
          <div class="fw-medium text-truncate text-nowrap me-2 mb-1" style="font-size: 20px; color: #030303">{{ jobInfo.jobTitle }}</div>
          <div class="d-flex align-items-center flex-grow-0 flex-shrink-0" style="margin-top: -4px">
            <mat-icon color="primary" class="md-icon-30 cursor-pointer" (click)="closeChat()">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div class="w-100 d-flex align-items-center text-truncate text-nowrap flex-grow-0">
          <div class="d-flex align-items-center text-truncate text-nowrap" style="min-width: 20%; max-width: 50%; margin-right: 16px;">
            <mat-icon class="md-icon-18 me-0 mat-color-accent-500 flex-shrink-0">business</mat-icon>
            <span class="body-sm ms-1 mat-color-gray-600 text-truncate text-nowrap">{{ jobInfo.companyName || 'No Company Name Available' }}</span>
            <!-- <span class="body-sm ms-2 text-truncate"> {{ item.value.companyName || 'No Current Company' }}</span> -->
          </div>

          <div class="d-flex align-items-center text-truncate"  style="min-width: 20%; max-width: 50%">
            <mat-icon class="md-icon-16 me-0 mat-color-accent-500 flex-shrink-0">location_on</mat-icon>
            <span class="body-sm ms-1 mat-color-gray-600 text-truncate">
              {{ jobInfo.locationGeoDisplay || 'No Location Available' }}
            </span>
          </div>
        </div>   
      </div>
    </div>
  </ng-container>

  <ng-template #candidateMsg>
    <div style="padding: 12px; border-bottom: 1px solid #BDBDBD;" >
      <div style="width: 44px; margin-right: 8px; display: inline-block; vertical-align: top;">
        <div style="width: 44px; height: 44px; border-radius: 4px; border: 1px solid #8BC34A; background-size: cover; background-position: center" [ngStyle]="{'background-image': 'url(' + localProfiles[0].imgUrl + ')', 'border': localProfiles[0].wasRead ? '1px solid #8BC34A' : '3px solid #8BC34A'}" *ngIf="localProfiles[0].imgUrl"></div>
        <app-user-avatar [name]="localProfiles[0].displayName" [squareMode]="true" [size]="'35px'" class="pe-2 flex-shrink-0" *ngIf="!localProfiles[0].imgUrl"></app-user-avatar>
      </div>
      <div style="display: inline-block; vertical-align: top; width: 350px">
        <div class="d-flex align-items-center justify-content-between" style="margin-top: -1px; margin-bottom: 3px">
          <div class="d-flex align-items-center text-truncate text-nowrap">
            <div class="fw-medium text-truncate text-nowrap me-2" style="height: 21px; font-size: 20px; color: #030303">{{ localProfiles[0].displayName }}</div>
            <div 
              class="body-sm me-1 flex-grow-0  flex-shrink-0 text-nowrap" 
              style="min-width: 61px; padding: 2px 4px; margin-top: 3px; font-size: 10px; border-radius: 4px; background-color: #FFEEBB"
              *ngIf="localProfiles[0].onHold">Paused communication</div>
            <div 
              class="p-1 body-sm me-1 text-nowrap flex-shrink-0" 
              style="min-width: 61px; padding: 2px 4px; margin-top: 3px;  font-size: 10px; border-radius: 4px; background-color: #FFC107"
              *ngIf="localProfiles[0].smsOptedOut">Opt-out</div>
            <div 
              class="p-1 body-sm me-1 text-nowrap flex-shrink-0" 
              style="min-width: 61px; padding: 2px 4px; margin-top: 3px;  font-size: 10px; border-radius: 4px; background-color: #E1BEE7"
              *ngIf="localProfiles[0].unsubscribe">Unsubscribed</div>
          </div>
          <div class="d-flex align-items-center flex-grow-0 flex-shrink-0" style="margin-top: -4px">
            <mat-icon color="primary" class="me-2 md-icon-18 cursor-pointer" (click)="handleArchiveChat()">archive</mat-icon>
            <mat-icon color="primary" class="md-icon-30 cursor-pointer" (click)="closeChat()">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div class="d-flex align-items-center body-sm mat-color-gray-600 text-truncate text-nowrap flex-grow-0" style="margin-top: -4px">
          <div class="text-truncate text-nowrap">{{ localProfiles[0].candidateTitle || localProfiles[0].displayName || 'No job title' }}</div>
          <div style="margin: 0 4px;">|</div>
          <div class="text-truncate text-nowrap">{{ localProfiles[0].companyName || 'No company name' }}</div>
        </div>
      </div>
    </div>
  </ng-template>

  <div style="margin: 12px 12px 0; padding: 8px; height: 76px; border: 1px solid #E0E0E0; border-radius: 4px;" class="overflow-hidden" *ngIf="isBulk">
    <ng-scrollbar #bulkMessages>
      <!-- <div class="d-flex flex-wrap align-items-start postition-relative" style="gap: 8px; height: 58px;" (click)="focusOnCandidatesInput()"> -->
      <div class="d-flex flex-wrap align-items-start postition-relative" style="gap: 8px; height: 58px;">
        <div class="d-flex align-items-center" style="height: 26px;">Send message to:</div>
        <div 
          class="d-flex align-items-center mat-background-gray-100 text-truncate" 
          style="padding: 3px; height: 26px; border: 1px solid #E0E0E0; border-radius: 4px;" 
          (click)="$event.stopPropagation()" 
          [class.has-error]="!!candidate.errorCode"
          [matTooltip]="candidate.errorMessage"
          *ngFor="let candidate of localProfiles">
          <span style="margin-right: 3px">{{ candidate.displayName }}</span>
          <mat-icon class="md-icon-16" (click)="removeCandidate(candidate.profileRef)">close</mat-icon>  
        </div> 

        <!-- <input type="text" class="hidden-input" (input)="searchBulkCandidates($event)" #hiddenCandidateSearchInput> -->
      </div>
    </ng-scrollbar>

    <div #bulkCandidatesSearchMenu class="position-absolute bg-white bulk-candidates-search-menu" style="top: 150px; right: -100px; z-index: 3; width: 388px; border: 1px solid #BDBDBD; border-radius: 4px;">
      <ng-scrollbar style="height: 160px;">
        <div class="d-flex align-items-center text-truncate text-nowrap cursor-pointer" style="padding: 16px;" *ngFor="let candidate of searchedCandidates" (click)="addCandidate(candidate)">
          <div class="body-lg me-2 text-truncate text-nowrap" style="color: #030303">{{ candidate.displayName }}</div>
          <div class="mat-color-gray-600 text-truncate text-nowrap" style="font-size: 10px;">{{ jobInfo.jobTitle }}</div>
          <div class="mat-background-color-300 me-2" style="margin: 0 4px; width: 1px; height: 12px;"></div>
          <div class="mat-color-gray-600 text-truncate text-nowrap" style="font-size: 10px;">{{ jobInfo.companyName || 'No Company Name Available' }}</div>
        </div>
      </ng-scrollbar>
    </div>

  </div>
  
  <div class="d-flex flex-column flex-grow-1 chat" style="padding: 12px; height: calc(100% - 180px)">
    <!-- <div> -->

      <ng-scrollbar #scrollbarMsg class="d-flex flex-column justify-content-end flex-grow-1 mat-background-gray-50" style="padding: 16px 12px; border: 1px solid #E0E0E0; border-radius: 8px;">
        <div class="chat-messages-wrapper" *ngIf="isBulk">
          <div *ngIf="isBulkSent" style="padding: 8px">{{ bulkSuccessMsg }}</div>
        </div>
        
        <div class="chat-messages-wrapper" #chatMessagesWrapper *ngIf="!isBulk">
          <!-- LOOPS THREADS -->
          <div *ngFor="let message of chat  let i = index">
            <!-- LOOPS MSG: -->
            <div class="body-sm text-center" style="padding: 16px 12px; " *ngIf="i === 0 || message.jobId!== chat[i-1].jobId" >Started chatting about {{ message?.jobTitle }}</div>

              <div  >

                <div class="chat-divider-container body-sm text-center" *ngIf="i === 0 || message.date !== chat[i-1].date">
                  <div class="chat-divider">{{ message.date }}</div>
                </div>
                <!-- Candidate message  -->
                <div class="w-100 d-flex flex-column" style="margin-bottom: 16px; padding: 0 12px;" *ngIf="message.isIncoming">
                  <div class="d-flex justify-content-start" style="width: 334px; padding: 8px; border: 1px solid #E0E0E0; border-radius: 8px; background-color: white;">
                    <div style="width: 20px; margin-right: 8px;">
                        <div style="width: 20px; height: 20px; border-radius: 4px; border: 1px solid #8BC34A; background-size: cover; background-position: center" [ngStyle]="{'background-image': 'url(' + message.imgUrl + ')', 'border': message.wasRead ? '1px solid #8BC34A' : '3px solid #8BC34A'}" *ngIf="message.imgUrl"></div>
                        <app-user-avatar [name]="localProfiles[0].displayName" [squareMode]="true" [size]="'20px'" class="pe-2 flex-shrink-0" *ngIf="!message.imgUrl"></app-user-avatar>
                    </div>
                    <div class="body-lg">
                      <p>{{ message.messageBody }}</p>
                    </div>
                  </div>
          
                  <div class="d-flex align-items-center body-sm" style="margin-top: 5px;">
                
                    <span class="me-1">{{message.timeStamp | date:'yyyy-MM-dd HH:mm:ss' }}</span> 
                    <mat-icon class="md-icon-14">check_circle</mat-icon> 
                  </div>
                </div>
          
                <!-- HR message rest -->
                <div class="w-100 d-flex align-items-end flex-column" style="margin-bottom: 16px; padding: 0 12px;" *ngIf="!message.isIncoming">
                  <div class="d-flex text-end justify-content-start" style="width: 334px; padding: 8px; border: 1px solid #E0E0E0; border-radius: 8px; background-color: white;">
                    <div style="width: 20px; margin-right: 8px;">
                      <div style="width: 20px; height: 20px; border-radius: 50%; border: 1px solid #8BC34A; background-size: cover; background-position: center" [ngStyle]="{'background-image': 'url(' + message.imgUrl + ')', 'border': message.wasRead ? '1px solid #8BC34A' : '3px solid #8BC34A'}" *ngIf="message.imgUrl"></div>
                      <app-user-avatar [name]="message.userName" [size]="'20px'" class="pe-2 flex-shrink-0"></app-user-avatar>
                    </div>
                    <div class="body-lg">
                      <p>{{ message.messageBody }}</p>
                    </div>
                  </div>        

                  <div
                    class="d-flex align-items-center body-sm"
                    style="margin-top: 5px;"
                    [ngSwitch]="message.smsStatus"
                  >
                    <!-- Pending case -->
                    <div *ngSwitchCase="MessagesStatuses.PENDING">
                      Pending
                    </div>

                    <!-- Failure case -->
                    <div *ngSwitchCase="MessagesStatuses.FAILURE">
                      Failure
                    </div>

                    <!-- Default: timestamp + icon -->
                    <div *ngSwitchDefault>
                      <span class="me-1">
                        {{ message.timeStamp | date: 'yyyy-MM-dd HH:mm:ss' }}
                      </span>
                      <mat-icon class="md-icon-14">check_circle</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            <!-- </ng-container> -->

            <div class="body-sm text-center" style="padding: 16px 12px; " *ngIf="activeTopic.length === 0" >The chat with the candidate has been archived</div>
            
          </div>
        </div>
        
      </ng-scrollbar>
      


    <div class="msg-panels flex-shrink-0" *ngIf="!isBulk">
      <mat-expansion-panel style="margin-top: 12px;" [expanded]= "activeTopic.length>0">
        <mat-expansion-panel-header class="p-0 body-sm" style="width: fit-content; height: auto; background-color: transparent;">
          <span style="margin-right: 8px;">Topic</span>  
        </mat-expansion-panel-header>
        <div class="d-flex flex-wrap" style="max-width: 100%; gap: 8px;">
          <div class="d-flex align-items-center text-nowrap text-truncate" style="padding: 4px 8px; background-color: #F1F8E9; border-radius: 4px; border: 1px solid #E0E0E0; max-width: 100%; overflow: hidden;" *ngFor="let topic of activeTopic">
            <span class="text-nowrap text-truncate" style="color: #030303;">{{ topic.jobTitle }}</span>
            <!-- <span class="flex-grow-0" style="color: #BDBDBD; margin: 0 8px; font-size: 21px;">|</span> -->
            <!-- <span class="text-nowrap text-truncate" style="color: #030303;">Green Grove Hospital</span> -->
            <mat-icon class="md-icon-19 flex-grow-0 flex-shrink-0 cursor-pointer" style="color: #5E5E5E; margin-left: 8px;" (click)="removeActiveTopic()">close</mat-icon>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel style="margin-top: 12px;">
        <mat-expansion-panel-header class="p-0 body-sm" style="width: fit-content; height: auto; background-color: transparent;">
          <span style="margin-right: 8px;">Recent topics</span>  
        </mat-expansion-panel-header>
        <div class="d-flex flex-wrap" style="max-width: 100%; gap: 8px;">
          <div class="d-flex align-items-center text-nowrap text-truncate" style="padding: 4px 6px; background-color: #F5F5F5; border-radius: 4px; border: 1px solid #E0E0E0; max-width: 100%; overflow: hidden;" *ngFor="let topic of recentTopics; let i = index">
            <span class="text-nowrap text-truncate" style="color: #030303;">{{ topic.jobTitle }}</span>
            <!-- <span class="flex-grow-0" style="color: #BDBDBD; margin: 0 8px; font-size: 21px;">|</span> -->
            <!-- <span class="text-nowrap text-truncate" style="color: #030303;">ProRank</span> -->
            <mat-icon svgIcon="add" class="flex-grow-0 flex-shrink-0 cursor-pointer" style="color: #5E5E5E; margin-left: 8px; margin-top: -2px; width: 14px; height: 18px; font-size: 17px" (click)="addActiveTopic(i, 'recent')"></mat-icon>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel style="margin-top: 12px;">
        <mat-expansion-panel-header class="p-0 body-sm" style="width: fit-content; height: auto; background-color: transparent;">
          <span style="margin-right: 8px;">Recommended jobs</span>  
        </mat-expansion-panel-header>
        <div class="d-flex flex-wrap" style="max-width: 100%; gap: 8px;">
          <div class="d-flex align-items-center text-nowrap text-truncate" style="padding: 4px 6px; background-color: #F5F5F5; border-radius: 4px; border: 1px solid #E0E0E0; max-width: 100%; overflow: hidden;" *ngFor="let topic of recommendedJobs; let i = index">
            <!-- <mat-icon class="md-icon-18 flex-grow-0 flex-shrink-0" style="color: #757575; margin-right: 8px; transform: rotate(180deg) scaleX(-1);">content_copy</mat-icon> -->
            <span class="text-nowrap text-truncate" style="color: #030303;">{{ topic.jobTitle }}</span>
            <!-- <span class="flex-grow-0" style="color: #BDBDBD; margin: 0 8px; font-size: 21px;">|</span> -->
            <!-- <span class="text-nowrap text-truncate" style="color: #030303;">ProRank</span> -->
            <mat-icon svgIcon="add" class="flex-grow-0 flex-shrink-0 cursor-pointer" style="color: #5E5E5E; margin-left: 8px; margin-top: -2px; width: 14px; height: 18px; font-size: 17px" (click)="addActiveTopic(i, 'recommended')"></mat-icon>
          </div>

          <!-- <div class="d-flex align-items-center text-nowrap text-truncate" style="padding: 4px 6px; background-color: #F5F5F5; border-radius: 4px; border: 1px solid #E0E0E0; max-width: 100%; overflow: hidden;">
            <mat-icon class="md-icon-18 flex-grow-0 flex-shrink-0" style="color: #757575; margin-right: 8px; transform: rotate(180deg) scaleX(-1);">content_copy</mat-icon>
            <span class="text-nowrap text-truncate" style="color: #030303;">Manager</span>
            <span class="flex-grow-0" style="color: #BDBDBD; margin: 0 8px; font-size: 21px;">|</span>
            <span class="text-nowrap text-truncate" style="color: #030303;">ProRank</span>
            <mat-icon svgIcon="add" class="flex-grow-0 flex-shrink-0" style="color: #5E5E5E; margin-left: 8px; margin-top: -2px; width: 14px; height: 18px; font-size: 17px"></mat-icon>
          </div>

          <div class="d-flex align-items-center text-nowrap text-truncate" style="padding: 4px 6px; background-color: #F5F5F5; border-radius: 4px; border: 1px solid #E0E0E0; max-width: 100%; overflow: hidden;">
            <mat-icon class="md-icon-18 flex-grow-0 flex-shrink-0" style="color: #757575; margin-right: 8px; transform: rotate(180deg) scaleX(-1);">content_copy</mat-icon>
            <span class="text-nowrap text-truncate" style="color: #030303;">Oncologist</span>
            <span class="flex-grow-0" style="color: #BDBDBD; margin: 0 8px; font-size: 21px;">|</span>
            <span class="text-nowrap text-truncate" style="color: #030303;">ProRank</span>
            <mat-icon svgIcon="add" class="flex-grow-0 flex-shrink-0" style="color: #5E5E5E; margin-left: 8px; margin-top: -2px; width: 14px; height: 18px; font-size: 17px"></mat-icon>
          </div> -->
        </div>
      </mat-expansion-panel>
    </div>

     <div *ngIf="errorMessage && !isBulk" style=" height: auto; display: block; padding: 8px; margin-top: 12px; border: 1px solid red; border-radius: 8px;">
      {{ errorMessage }}
     </div>
    <div 
      class="message-input-box flex-shrink-0"
      [ngClass]="{'disabled-textarea' : errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) }" 
      style="min-height: 120px; height: auto; overflow: auto; display: block; padding: 8px; margin-top: 12px; border: 1px solid #E0E0E0; border-radius: 8px;">
      <textarea
        #msgInput
        [ngClass]="{ 'disabled': errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) }"
        [(ngModel)]="smsMsg"
        (input)="resizeTextArea($event)"
        class="w-100"
        style="min-height: 60px; max-height: 140px; background: #fff; border: none; font-size: 16px;"
        [placeholder]="errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) ? '' : 'Type a message. Or click + to select a template or smart text.'"
      ></textarea>

      <div class="d-flex align-items-end justify-content-between">
        <div>
          <mat-icon 
            class="md-icon-24 cursor-pointer" 
            style="margin-right: 11px" 
            [matMenuTriggerFor]="emojiMenu" 
            #emojiTrigger="matMenuTrigger"
            [ngClass]="{ 'disabled': errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) }" 
            color="primary">mood</mat-icon>

          <mat-menu #emojiMenu="matMenu" class="emoji-menu" (click)="$event.preventDefault()">
            <div (click)="$event.stopPropagation()">
              <emoji-mart (emojiSelect)="addEmoji($event)"></emoji-mart>
            </div>
          </mat-menu>

          <mat-icon 
            class="cursor-pointer" 
            color="primary" 
            [matMenuTriggerFor]="msgTypeMenu"
            [ngClass]="{ 'disabled': errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) }"
            >add</mat-icon>
          
          <mat-menu #msgTypeMenu="matMenu" class="msg-type-menu" xPosition="before" yPosition="above">
            <div  >
              
              <button 
                mat-flat-button 
                class="w-100 flex-column align-items-start justify-content-center text-start"
                style="height: 82px; padding: 8px 16px; border-radius: 0;"
                [ngClass]="{ 'disabled': errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors) }"
                (click)="openSmsTemplatesMenu()"
                >
                  <div class="body-lg mb-2">SMS Templates</div>
                  <div style="font-size: 10px">Preset text templates to get you started</div>
              </button>
              <div class="w-100" style="height: 1px; background-color: #BDBDBD"></div>
              <button 
                mat-flat-button 
                class="w-100 flex-column align-items-start justify-content-center text-start"
                style="height: 82px; padding: 8px 16px; border-radius: 0;"
                (click)="openSmartTextMenu()">
                  <div class="body-lg mb-2">Smart text</div>
                  <div style="font-size: 10px">Use variables (eg. FirstName) to personalize without the extra effort.</div> 
              </button>
            
            </div>
          </mat-menu>

          <button 
            style="width: 0px; height: 0px; opacity: 0"
            [ngClass]="{ 'disabled': (errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors)) }" 
            #smsTemplateTrigger="matMenuTrigger"
            [matMenuTriggerFor]="smsTemplatesMenu">
          </button>  

          <mat-menu #smsTemplatesMenu="matMenu" class="sms-templates-menu" xPosition="after" (click)="$event.preventDefault()">
            <div style="padding: 16px;">
              <div class="fw-medium" style="font-size: 20px; padding: 0 8px 16px" (click)="$event.stopPropagation()">SMS Templates</div>
              <div *ngIf="{ templates: outreachTempalte$ | async } as result">
                <ng-container  *ngIf="result.templates" >
              <ng-container *ngFor="let template of result.templates" > 
                <button 
                  mat-flat-button 
                  class="w-100 flex-column align-items-start justify-content-center text-start"
                  style="height: 82px; margin-bottom: 12px; padding: 8px 16px; border: 1px solid #E0E0E0;"
                  (click)="addText(template.templateTypeId);">
                  <div class="body-lg mb-2">{{template.templateDesc}}</div>
                  
               </button>
                </ng-container>
              </ng-container>
              </div>
            </div>
          </mat-menu>

          <button style="width: 0px; height: 0px; opacity: 0"  #smartTextTemplateTrigger="matMenuTrigger"
          [matMenuTriggerFor]="smartTextTemplatesMenu"></button>  

          <mat-menu #smartTextTemplatesMenu="matMenu" class="sms-templates-menu" xPosition="after" (click)="$event.preventDefault()">
            <!-- <ng-scrollbar> -->
              <div style="padding: 16px; height: 100%" (click)="$event.stopPropagation()">
                <div class="fw-medium" style="font-size: 16px; padding-bottom: 12px" >Smart Text (Substitution Variables)</div>
                <div class="d-flex flex-wrap" style="row-gap: 8px; column-gap: 12px;" *ngIf="{ outreachVars: outreachVars$ | async } as res">
                
                <ng-container  *ngIf="res.outreachVars" >
              <ng-container *ngFor="let outreachVar of res.outreachVars" > 
                  <div class="cursor-pointer" style="padding: 4px; background-color: #F5F5F5; width: 48%; border-radius: 4px; border: 1px solid #E0E0E0"
                   (click)="$event.stopPropagation(); addVar(outreachVar.varName)"> {{outreachVar.varName }}</div>
               </ng-container>
                </ng-container>
                </div>
              </div>
            <!-- </ng-scrollbar> -->
          </mat-menu>

        </div>

        <div class="d-flex align-items-center">
          <div>{{ smsMsg.length || 0 }} <span *ngIf="smsMsg.length">- {{ smsMsg | smsCredits }} contact credits</span></div>
          <button 
            class="square-icon-btn square-icon-btn__sm send-sms-btn" 
            [ngClass]="{ 'disabled': (errorMessage && !isBulk || (errorMessage && isBulk && bulkAllErrors)) || smsMsg.length === 0 || smsIsLoading }"
            style="background-color: transparent;" 
            mat-button 
            (click)="sendSms()"
            >
            <mat-icon class="md-icon-20 me-0">arrow_forward</mat-icon>
          </button> 

        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-end" style="padding-top: 12px;">
      <span class="flex-shrink-0" style="margin-right: 8px;">Active line:</span>
      
      <!-- Add condition here, check if recruiter self or not -->
      <ng-container  >
        <app-user-avatar [name]="selectedUser?.firastName" [squareMode]="true" [size]="'18px'" class="pe-2 flex-shrink-0"></app-user-avatar>
        <span class="fw-medium text-nowrap text-truncate" style="margin-right: 4px;">{{selectedUser?.firstName +' '+ selectedUser?.lastName}}</span>  
        <span class="flex-shrink-0" style="margin-right: 4px;" *ngIf="selectedUser?.phoneNumber">with</span>  
        <span class="fw-medium flex-shrink-0" style="margin-right: 12px;">{{selectedUser?.phoneNumber}}</span>  
      </ng-container>

       
      
      <mat-icon svgIcon="caret_down" class="md-icon-16 flex-shrink-0 cursor-pointer" style="margin-top: -5px;" #activeLineMenuTrigger [matMenuTriggerFor]="activeLineMenu" color="primary"></mat-icon>
      
      <mat-menu #activeLineMenu="matMenu" xPosition="before" yPosition="above" class="active-line-menu">
        <div style="padding: 16px 8px;" (click)="$event.stopPropagation()">
          <div class="fw-medium" style="font-size: 20px; padding: 0 8px 16px">Pick an active line</div>
          <div *ngFor="let user of usersPhoneNumbers">
            <button 
              mat-flat-button 
              class="w-100 justify-content-start align-items-center"
              style="height: 44px; padding: 0 8px;"
              (click)="$event.stopPropagation(); selectUser(user)">
                <app-user-avatar [name]="user.firstName" [squareMode]="true" [size]="'18px'" class="pe-2 flex-shrink-0"></app-user-avatar>
                <span class="fw-medium text-nowrap text-truncate" style="margin-right: 4px;">  {{user.firstName +' '+ user.lastName}} </span>  
                <span class="flex-shrink-0" style="margin-right: 4px;" *ngIf="user.phoneNumber">with</span>  
                <span class="fw-medium flex-shrink-0" style="margin-right: 12px;">{{user.phoneNumber}}</span>  
            </button>
            
          </div>
        </div>
      </mat-menu>
    </div>

    <!-- <div class="disabled-msg">
      <div class="fw-medium" style="font-size: 20px; margin-bottom: 20px;">You cannot message this candidate</div>
      <div class="d-flex align-items-center" style="margin-bottom: 3px">
        <app-user-avatar [name]="'Michael Scott'" [squareMode]="true" [size]="'18px'" class="pe-2 flex-shrink-0"></app-user-avatar>
        <span class="fw-medium text-nowrap text-truncate" style="margin-right: 4px;">Michael Scott</span>  
        <span class="flex-shrink-0" style="margin-right: 4px;">with</span>  
        <span class="fw-medium flex-shrink-0" style="margin-right: 12px;">(224) 927 - 9083</span> 
      </div>
      <div style="margin-bottom: 20px;">
        <p>is already in a conversation with this candidate. Switch to their profile to continue this conversation</p> 
      </div>
      <div>
        <button mat-stroked-button class="me-3 body-lg" style="width: 173px; height: 44px;">
          <span style="font-size: 16px;">Go back</span>  
        </button>
        <button mat-flat-button color="primary" style="width: 173px; height: 44px;">Switch profile</button>
      </div>
    </div> -->
  </div>
</div>

<ng-template #archiveModal>
  <div class="d-flex mx-2 mt-2 p-3" mat-dialog-title>
    <label class="text-primary">Warning</label>

    <button mat-dialog-close mat-mini-fab color="primary" class="ms-auto">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="mt-1" mat-dialog-content>
    <div fxLayout="row">
      <mat-icon color="primary" class="md-icon-38">warning</mat-icon>
      <label class="ms-3">
        <b class="mb-1"> Archive chat with {{ localProfiles[0].displayName }}</b>
        <br />
        <div class="mt-1">Are you sure you want to archive chat?</div>
      </label>
    </div>
  </div>

  <mat-divider class="mat-background-gray-300"></mat-divider>

  <div class="d-flex justify-content-end" mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="closeConfirmationModal()">Cancel</button>

    <div class="ms-3" [matTooltip]="'Archive chat'">
      <button mat-raised-button color="primary" (click)="archiveChat(localProfiles[0].profileRef, localProfiles[0].displayName)">Archive chat</button>
    </div>
  </div>
</ng-template>